import React, { Suspense } from 'react';
import { LayoutSplashScreen } from '../../../_metronic/layout';
import Main from './MultiOverview';

function MultiOverview() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Main />
        </Suspense>
    );
}

export default MultiOverview;
